﻿<template>
  <div class="place">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="90px"
      class="demo-ruleForm"
      size='small'
    >
      <!-- 发件人 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.place.title.shipperInfo') }}</div>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-select v-model="sendSelectValue" :placeholder="$t('order.place.title.selectSenderAddress')" filterable size="small" style="width:180px;margin-left: 10px" @change='selectSendAddr'>
            <el-option
              v-for="(item,index) in send_list"
              :key="index"
              :label="item.realname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.name')" prop="send_data.realname">
            <el-input v-model="ruleForm.send_data.realname" :placeholder="$t('order.place.placeholder.enterName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.company')" prop="send_data.company">
            <el-input v-model="ruleForm.send_data.company" :placeholder="$t('order.place.placeholder.enterCompany')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.country')" prop="send_data.country">
            <el-select v-model="ruleForm.send_data.country" :placeholder="$t('order.place.placeholder.selectCountry')" style="width: 100%" @change="handleSendChange">
              <el-option v-for="(item,index) in countryList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="120px" :label="$t('order.place.label.stateProvince')" prop="send_data.province">
            <el-select v-model="ruleForm.send_data.province" :placeholder="$t('order.place.placeholder.selectState')" style="width: 100%">
              <el-option v-for="(item,index) in sendProvinceList" :key="index" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.city')" prop="send_data.city">
            <el-input v-model="ruleForm.send_data.city" :placeholder="$t('order.place.placeholder.enterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.zipCode')" prop="send_data.zcode">
            <el-input v-model="ruleForm.send_data.zcode" :placeholder="$t('order.place.placeholder.enterZipCode')" @blur="getCityInfo(1)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address1')" prop="send_data.address_one">
            <el-input v-model="ruleForm.send_data.address_one" :placeholder="$t('order.place.placeholder.enterAddress1')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address2')" prop="send_data.address_two">
            <el-input v-model="ruleForm.send_data.address_two" :placeholder="$t('order.place.placeholder.enterAddress2')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address3')" prop="send_data.address_three">
            <el-input v-model="ruleForm.send_data.address_three" :placeholder="$t('order.place.placeholder.enterAddress3')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.phone')" prop="send_data.mobile">
            <el-input v-model="ruleForm.send_data.mobile" :placeholder="$t('order.place.placeholder.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.email')" prop="send_data.email">
            <el-input v-model="ruleForm.send_data.email" :placeholder="$t('order.place.placeholder.enterEmail')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 发件人操作按钮：单独一行，避免与地址3挤在同一列 -->
      <el-row :gutter="10" style="margin-bottom: 18px">
        <el-col :span="24" style="text-align:right">
          <el-button type="warning" @click="clearAddress(1)" size='small' class="add-select-btn">{{ $t('order.place.button.clear') }}</el-button>
          <el-button type="primary" @click="swapAddress" size="small" class="add-select-btn">{{ $t('order.place.button.swapAddress') }}</el-button>
          <el-button type="primary" @click="handleResolution(1)" size="small" class="add-select-btn">{{ $t('order.fplace.resolution.jiexidizhi') }}</el-button>
          <el-button type="success" @click="addAddress('ruleForm',1)" size='small' class="add-select-btn">{{ $t('order.place.button.saveToAddressBook') }}</el-button>
        </el-col>
      </el-row>
      <!-- 收件人 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.place.title.consigneeInfo') }}</div>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-select v-model="FbaValue" :placeholder="$t('order.place.title.selectFbaAddress')" filterable size="small" style="width:180px;margin-left: 10px" @change='selectFBAAddr'>
            <el-option
              v-for="(item,index) in fbaLists"
              :key="index"
              :label="item.fba_code"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="receiveSelectValue" filterable :placeholder="$t('order.place.title.selectReceiverAddress')" size="small" style="width:180px;margin-left: 10px" @change='selectReceiveAddr'>
            <el-option
              v-for="(item,index) in receive_list"
              :key="index"
              :label="item.realname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.name')" prop="receive_data.realname">
            <el-input v-model="ruleForm.receive_data.realname" :placeholder="$t('order.place.placeholder.enterName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.company')" prop="receive_data.company">
            <el-input v-model="ruleForm.receive_data.company" :placeholder="$t('order.place.placeholder.enterCompany')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.country')" prop="receive_data.country">
            <el-select v-model="ruleForm.receive_data.country" :placeholder="$t('order.place.placeholder.selectCountry')" style="width: 100%" @change="handleReceiveChange">
              <el-option v-for="(item,index) in countryList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="120px" :label="$t('order.place.label.stateProvince')" prop="receive_data.province">
            <el-select v-model="ruleForm.receive_data.province" :placeholder="$t('order.place.placeholder.selectState')" style="width: 100%">
              <el-option v-for="(item,index) in receiveProvinceList" :key="index" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.city')" prop="receive_data.city">
            <el-input v-model="ruleForm.receive_data.city" :placeholder="$t('order.place.placeholder.enterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.zipCode')" prop="receive_data.zcode">
            <el-input v-model="ruleForm.receive_data.zcode" :placeholder="$t('order.place.placeholder.enterZipCode')" @blur="getCityInfo(2)"></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address1')" prop="receive_data.address_one">
            <el-input v-model="ruleForm.receive_data.address_one" :placeholder="$t('order.place.placeholder.enterAddress1')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address2')" prop="receive_data.address_two">
            <el-input v-model="ruleForm.receive_data.address_two" :placeholder="$t('order.place.placeholder.enterAddress2')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address3')" prop="receive_data.address_three">
            <el-input v-model="ruleForm.receive_data.address_three" :placeholder="$t('order.place.placeholder.enterAddress3')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.phone')" prop="receive_data.mobile">
            <el-input v-model="ruleForm.receive_data.mobile" :placeholder="$t('order.place.placeholder.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.email')" prop="receive_data.email">
            <el-input v-model="ruleForm.receive_data.email" :placeholder="$t('order.place.placeholder.enterEmail')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 收件人操作按钮：单独一行，避免与地址3挤在同一列 -->
      <el-row :gutter="10" style="margin-bottom: 18px">
        <el-col :span="24" style="text-align: right">
          <el-button type="warning" @click="clearAddress(2)" size='small' class="add-select-btn">{{ $t('order.place.button.clear') }}</el-button>
          <el-button type="warning" @click="addAddress('ruleForm',3)" size='small' class="add-select-btn">{{ $t('order.place.button.verifyAddress') }}</el-button>
          <el-button type="primary" @click="swapAddress" size="small" class="add-select-btn">{{ $t('order.place.button.swapAddress') }}</el-button>
          <el-button type="primary" @click="handleResolution(2)" size="small" class="add-select-btn">{{ $t('order.fplace.resolution.jiexidizhi') }}</el-button>
          <el-button type="success" @click="addAddress('ruleForm',2)" size='small' class="add-select-btn">{{ $t('order.place.button.saveToAddressBook') }}</el-button>
        </el-col>
      </el-row>
      <!-- 货运/商品 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.place.title.cargoGoods') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item class="is-no-asterisk" :label="$t('order.place.label.logisticsChannel')" prop="goods_info.pservice_type">
            <el-select v-model="ruleForm.goods_info.pservice_type" :placeholder="$t('order.place.placeholder.selectLogisticsChannel')" style="width: 100%" @change="changePservice">
              <el-option v-for="(item,index) in channelList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="100px" :label="$t('order.place.label.ecommerceOrderNo')" prop="goods_info.hb_order_sn">
            <el-input v-model="ruleForm.goods_info.hb_order_sn" :placeholder="$t('order.place.placeholder.enterEcommerceOrderNo')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.labelRemark')" prop="goods_info.order_remark">
            <el-input v-model="ruleForm.goods_info.order_remark" :placeholder="$t('order.place.placeholder.enterLabelRemark')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.remarks')" prop="goods_info.note">
            <el-input v-model="ruleForm.goods_info.note" :placeholder="$t('order.place.placeholder.enterRemarks')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.shipDate')" prop="goods_info.shipment_date">
            <el-date-picker
              v-model="ruleForm.goods_info.shipment_date"
              style="width: 100%"
              type="date"
              value-format='yyyy-MM-dd'
              format="yyyy-MM-dd"
              :placeholder="$t('order.place.placeholder.selectShipDate')">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.signatureRequired')" prop="goods_info.is_sign">
            <el-select v-model="ruleForm.goods_info.is_sign" :placeholder="$t('order.place.placeholder.selectSignature')" style="width: 100%">
              <el-option :label="$t('order.place.options.signature.noSignature')" :value="0"></el-option>
              <el-option :label="$t('order.place.options.signature.adultSignature')" :value="1"></el-option>
              <el-option :label="$t('order.place.options.signature.standardSignature')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 预约取件 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title"><el-checkbox v-model="is_qus" @change="handleCheck" style="margin-right: 5px;"></el-checkbox>{{ $t('order.place.title.scheduledPickup') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.name')" prop="q_data.realname">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.realname" :placeholder="$t('order.place.placeholder.enterName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.company')" prop="q_data.company">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.company" :placeholder="$t('order.place.placeholder.enterCompany')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.country')" prop="q_data.country">
            <el-select :disabled="!is_qus" v-model="ruleForm.q_data.country" :placeholder="$t('order.place.placeholder.selectCountry')" style="width: 100%" @change="handleQChange">
              <!-- <el-option v-for="(item,index) in countryList" :key="index" :label="item.label" :value="item.value"></el-option> -->
              <el-option label="United States" value="United States"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.stateProvince')" prop="q_data.province">
            <el-select :disabled="!is_qus" v-model="ruleForm.q_data.province" :placeholder="$t('order.place.placeholder.selectState')" style="width: 100%">
              <el-option v-for="(item,index) in qProvinceList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.city')" prop="q_data.city">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.city" :placeholder="$t('order.place.placeholder.enterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.zipCode')" prop="q_data.zcode">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.zcode" :placeholder="$t('order.place.placeholder.enterZipCode')" @blur="getCityInfo(3)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address1')" prop="q_data.address_one">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.address_one" :placeholder="$t('order.place.placeholder.enterAddress1')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.address2')" prop="q_data.address_two">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.address_two" :placeholder="$t('order.place.placeholder.enterAddress2')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.phone')" prop="q_data.mobile">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_data.mobile" :placeholder="$t('order.place.placeholder.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-button type="warning" @click="clearAddress(3)" size='small' class="add-select-btn">{{ $t('order.place.button.clear') }}</el-button>
        </el-col>
      </el-row>
      <!-- 封装信息 -->
      <el-row :gutter="10" class="border-col"  v-if="is_qus">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.place.title.packagingInfo') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.totalPackages')" prop="q_package.package_all_num">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_package.package_all_num" :placeholder="$t('order.place.placeholder.enterTotalPackages')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.totalWeight')" prop="q_package.all_weight">
            <el-input :disabled="!is_qus" v-model="ruleForm.q_package.all_weight" :placeholder="$t('order.place.placeholder.enterTotalWeight')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.pickupDate')" prop="q_package.q_date">
            <el-date-picker
              :disabled="!is_qus"
              v-model="ruleForm.q_package.q_date"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              :picker-options="pickupDatePickerOptions"
              :placeholder="$t('order.place.placeholder.selectPickupDate')">
            </el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="10" v-if="is_qus"> 
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.readyTime')" prop="q_package.q_time">
            <el-select :disabled="!is_qus" v-model="ruleForm.q_package.q_time" :placeholder="$t('order.place.placeholder.selectReadyTime')" style="width: 100%" @change="changeTime">
              <el-option v-for="(item,index) in qtimelist" :key="index" :label="item" :value="item" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.place.label.latestTime')" prop="q_package.q_endtime">
            <el-select :disabled="!is_qus" v-model="ruleForm.q_package.q_endtime" :placeholder="$t('order.place.placeholder.selectLatestTime')" style="width: 100%">
              <el-option v-for="(item,index) in qendtimelist" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('order.place.label.specialInstructions')" prop="q_package.package_remark">
            <el-input :disabled="!is_qus" type="textarea" :rows="2" v-model="ruleForm.q_package.package_remark" :placeholder="$t('order.place.placeholder.enterSpecialInstructions')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 包裹 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="24">
          <div class="place-title" style="display:flex;">{{ $t('order.place.title.packageInfo') }}
            <el-radio-group v-model="pa_unit" size='small' style="margin-left: 10px">
              <el-radio-button :label="$t('order.place.unit.lbIn')" :value='1'></el-radio-button>
              <el-radio-button :label="$t('order.place.unit.kgCm')" :value='2'></el-radio-button>
            </el-radio-group>
            <span class="tips">{{ $t('order.place.tips.weightDimensions') }}</span>
          </div>
        </el-col>
      </el-row>
      <div class="parcel-item" v-for="(item,index) in  ruleForm.package_list" :key="index">
          <div class="parcel-top">
            <span class="parcel-title">{{index+1}}-{{ $t('order.place.title.packageInfo') }}</span>
            <i style="font-size: 20px;margin:0 10px;color:#409DFE;cursor: pointer;" class="el-icon-circle-plus-outline" @click="addParcel"></i>
            <i style="font-size: 20px;color:#F56C6C;cursor: pointer;margin-right:10px" class="el-icon-remove-outline" v-if="ruleForm.package_list.length > 1" @click="delParcel(index)"></i>
          </div>
        <el-row :gutter="10"> 
          <el-col :span="8">
            <el-form-item :label="$t('order.place.label.packageType')" label-width="110px">
              <el-select v-model="item.pa_type" style="width: 100%" @change="(val) => handlePackageTypeChange(val, index)">
                <el-option :label="item.label" :value="item.label" v-for="(item,index) in  pa_type_list" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('order.place.label.sku')" label-width="110px" :prop='`package_list[${index}][Sku]`' :rules="rules.Sku">
              <el-input v-model="item.Sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('order.place.label.packageQuantity')" label-width="110px" :prop='`package_list[${index}][pa_num]`' :rules="rules.pa_num">
              <div class="parcel-lwh">
                <el-input-number v-model="item.pa_num" :step="1" style="width:180px"></el-input-number>
                <el-button type="warning" size="small" @click="copyParcel(index,item)" style="margin-left:10px">{{ $t('order.place.button.copyPackage') }}</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10"> 
          <el-col :span="8">
            <el-form-item :label="pa_unit == $t('order.place.unit.lbIn') ? $t('order.place.label.dimensions') + ' (' + $t('order.place.unit.in') + ')' : $t('order.place.label.dimensions') + ' (' + $t('order.place.unit.cm') + ')'" label-width="110px" :prop='`package_list[${index}][pa_length]`' :rules="item.pa_type == 'Your Packaging' ? rules.pa_length : []">
              <div class="parcel-lwh">
                <el-input type='number' :controls='false' v-model="item.pa_length" style="width:100px"></el-input>*
                <el-input type='number' :controls='false' v-model="item.pa_width" style="width:100px"></el-input>*
                <el-input type='number' :controls='false' v-model="item.pa_height" style="width:100px"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="pa_unit == $t('order.place.unit.lbIn') ? $t('order.place.label.weight') + ' (' + $t('order.place.unit.lb') + ')' : $t('order.place.label.weight') + ' (' + $t('order.place.unit.kg') + ')'" label-width="110px" :prop='`package_list[${index}][pa_lb]`' :rules="rules.pa_lb">
              <div class="parcel-lwh">
                <el-input type='number' :controls='false' v-model="item.pa_lb" style="width:100%"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('order.place.label.declaredValue')" label-width="110px">
              <div class="parcel-lwh">
                <el-input v-model="item.insurance" style="width: 160px">
                  <template slot="prepend">{{ $t('order.place.unit.currency') }}</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item  :prop="`package_list[${index}][itemQty]`" :label="$t('order.fplace.label.itemQtyValue')" label-width="110px">
              <div class="parcel-lwh">
                <el-input v-model="item.itemQty" style="width: 160px"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      
      <!-- 包裹合计：总重量 / 总体积重量(长×宽×高÷系数,多包裹按数量相加) -->
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display:flex;flex-wrap:wrap;gap:12px 48px;align-items:center;margin:6px 0 12px;padding:10px 16px;background:#ecf5ff;border:1px solid #d9ecff;border-radius:4px;font-size:14px;color:#303133;">
            <span>{{ $t('order.parcel.totalWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalCargoWeight }} {{ weightUnitText }}</b></span>
            <span>{{ $t('order.parcel.totalVolumeWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalVolumeWeight }} {{ weightUnitText }}</b></span>
          </div>
        </el-col>
      </el-row>
      <!-- 按钮 -->
      <el-row :gutter="10">
        <el-col :span="24" class="bttn">
          <el-button type="warning" size="small" @click="handleFree('ruleForm')" :loading="freeLoading">{{ $t('order.place.button.predictRate') }}</el-button>
          <div class="free-rate" v-if="ratesMoney">
            {{ $t('order.place.ratePrediction.costPrediction') }}<span>{{ $t('order.place.unit.currency') }}{{ ratesMoney.toFixed(2) }} {{ $t('order.place.label.weight') }}：{{ ratesWeight }}</span>
          </div>
          <el-button type="success" size="small" @click="submitDraftForm('ruleForm')" :loading="draftLoading">{{ $t('order.place.button.saveDraft') }}</el-button>
          <el-button type="primary" size="small" @click="openImmediatePay('ruleForm')" :loading="orderLoading">{{ $t('recharge.payCreateShipment') }}</el-button>
          <el-button type="primary" size="small" @click="storeForm('ruleForm')" :loading="storeLoading">{{ $t('order.place.button.storeShipment') }}</el-button>
          <el-button @click="resetForm('ruleForm')" size="small" >{{ $t('order.place.button.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <OrderPayDialog :visible.sync="payVisible" :amount="ratesMoney" @success="onImmediatePaySuccess" />
    <!-- 面单 -->
        <RateProgress ref="rateProgress" :visible.sync="rateProgressVisible" streamType="domestic" @stream-complete="onRateStreamComplete" @stream-error="onRateStreamError" @stream-abort="onRateStreamAbort" />
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.place.dialog.predictCost')"
      append-to-body
      :visible.sync="freeVisible"
      width="1300px"
      :before-close="closeFreeDialog"
    >
      <Free
        v-if="freeVisible"
        :freeInfo="freeInfo"
        append-to-body
        @getRatesInfo='getRatesInfo'
      />
    </el-dialog>
    <!-- 校验地址后的提示 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.place.dialog.verifyResult')"
      append-to-body
      :visible.sync="checkVisible"
      width="400px"
      class="check-dialog"
      :before-close="closeCheckDialog"
    >
      <Check
        v-if="checkVisible"
        append-to-body
        @closeCheck='closeCheck'
        :checkInfo='checkInfo'
      />
    </el-dialog>
    <!-- 解析地址 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.fplace.resolution.jiexidizhi')"
      append-to-body
      :visible.sync="resoluVisible"
      width="900px"
    >
      <AddressResolution v-if="resoluVisible" :resoluNum="resoluNum" append-to-body @resoluResult="resoluResult" />
    </el-dialog>
  </div>
</template>

<script>
import { address, addressAdd } from '@/api/address'
import { orderCreate,fbaList, rates, orderInfo, saveOrder, cityInfo, storeOrder } from "@/api/order"
import { City, serviceNameList, checkAddress } from '@/api/common'
import Free from './components/free.vue';
import Check from './components/check.vue';
import RateProgress from './components/rateProgress.vue';
import OrderPayDialog from './components/orderPayDialog.vue';
import {
  validatenull,
  transformCountryCity,
  provinceListValue,
  findTimeIndex,
  normalizeAddressOverflow,
  formatPickupDateValue,
  isPickupDateBeforeToday,
} from "@/common/common.js"
import AddressResolution from "./components/addressResolution.vue";
export default {
  components: {
    Free,
    Check,
    RateProgress,
    AddressResolution,
    OrderPayDialog
  },
  props:{
    record: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      resoluNum: 0,
      resoluVisible: false,
      sendSelectValue: [],
      receiveSelectValue: [],
      pa_unit: '磅/英寸',
      FbaValue: '',
      freeVisible: false,
      freeInfo: {},
      checkVisible: false,
      checkInfo: {},
      ratesMoney: '',
      ratesWeight: '',
      freeLoading: false,
      rateProgressVisible: false,
      draftLoading: false,
      orderLoading: false,
      payVisible: false,
      storeLoading: false,
      pa_type_list: [
        { label: "Your 10kg Box" },
        { label: "Your 25kg Box" },
        { label: "Your Envelope" },
        { label: "Your Extra Large Box" },
        { label: "Your Large Box" },
        { label: "Your Medium Box" },
        { label: "Your Pak" },
        { label: "Your Small Box" },
        { label: "Your Tube" },
        { label: "Your Packaging" },
      ],
      qtimelist: ["7:00 am", "7:30 am", "8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm", "1:30 pm", "2:00 pm", "2:30 pm", "3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30 pm", "6:00 pm", "6:30 pm", "7:00 pm", "7:30 pm", "8:00 pm", "8:30 pm", "9:00 pm"],
      qendtimelist: [],
      ruleForm: {
        goods_info:{
          is_sign: 0,
          service_type: "",
          USPSEndorsement: 1
        },
        package_list: [
          {
            Sku: "001",
            insurance: 0,
            pa_height: '',
            pa_lb: '',
            itemQty: 1,
            pa_length: '',
            pa_num: 1,
            pa_type: "Your Packaging",
            pa_width: ''
          }
        ],
        receive_data: {
          company: '',
          address_two: '',
          address_three: '',
          email: '',
          country: 'United States'
        },
        send_data: {
          company: '',
          address_two: '',
          address_three: '',
          email: '',
          country: 'United States'
        },
        is_qu: 0,
        q_data: {
          company: '',
          address_two: '',
        },
        q_package: {}
      },
      is_qus: false,
      countryList: [],
      sendProvinceList: [],
      receiveProvinceList: [],
      qProvinceList: [],
      channelList: [],
      fbaLists: [],
      receive_list: [],
      send_list: [],
      send_oneself_list: [
        {
          name: 'CTSGCOCA',
          addr: {
            address_one: "2300 S EASTERN AVE",
            city: "Commerce",
            company: "Operation Manager",
            country: "United States",
            email: "jessiew@ctsglobalsolutions.com",
            mobile: "(626) 693-8893",
            province: "CA",
            realname: "Jessie Wang",
            zcode: "90040-1431",
          }
        },
        {
          name: 'CTSGSGNY',
          addr: {
            address_one: "14709 182ND ST",
            city: "Springfield Gardens",
            company: "Operation Manager",
            country: "United States",
            email: "ront@ctsglobalsolutions.com",
            mobile: "(626) 709-3199",
            province: "NY",
            realname: "Ron Tong",
            zcode: "11413-4034",
          }
        }
      ],
      id: ''
    };
  },
  computed: {
    pickupDatePickerOptions() {
      return {
        disabledDate: (time) => isPickupDateBeforeToday(
          time,
          this.ruleForm.q_data.country,
          this.ruleForm.q_data.province,
        ),
      }
    },
    rules() {
      return {
        'send_data.realname': [{ required: true, message: this.$t('order.place.validation.enterShipperName'), trigger: "blur" }],
        'send_data.country': [{ required: true, message: this.$t('order.place.validation.selectShipperCountry'), trigger: "change" }],
        'send_data.province': [{ required: true, message: this.$t('order.place.validation.selectShipperState'), trigger: "change" }],
        'send_data.city': [{ required: true, message: this.$t('order.place.validation.enterShipperCity'), trigger: "blur" }],
        'send_data.zcode': [{ required: true, message: this.$t('order.place.validation.enterShipperZip'), trigger: "blur" }],
        'send_data.address_one': [{ required: true, message: this.$t('order.place.validation.enterShipperAddress'), trigger: "blur" }],
        'send_data.mobile': [{ required: true, message: this.$t('order.place.validation.enterShipperPhone'), trigger: "blur" }],

        'receive_data.realname': [{ required: true, message: this.$t('order.place.validation.enterConsigneeName'), trigger: "blur" }],
        'receive_data.country': [{ required: true, message: this.$t('order.place.validation.selectConsigneeCountry'), trigger: "change" }],
        'receive_data.province': [{ required: true, message: this.$t('order.place.validation.selectConsigneeState'), trigger: "change" }],
        'receive_data.city': [{ required: true, message: this.$t('order.place.validation.enterConsigneeCity'), trigger: "blur" }],
        'receive_data.zcode': [{ required: true, message: this.$t('order.place.validation.enterConsigneeZip'), trigger: "blur" }],
        'receive_data.address_one': [{ required: true, message: this.$t('order.place.validation.enterConsigneeAddress'), trigger: "blur" }],
        'receive_data.mobile': [{ required: true, message: this.$t('order.place.validation.enterConsigneePhone'), trigger: "blur" }],

        'goods_info.pservice_type': [{ required: true, message: this.$t('order.place.validation.selectLogisticsChannel'), trigger: "change" }],

        'q_data.realname': [{ required: true, message: this.$t('order.place.validation.enterPickupName'), trigger: "blur" }],
        'q_data.country': [{ required: true, message: this.$t('order.place.validation.selectPickupCountry'), trigger: "change" }],
        'q_data.province': [{ required: true, message: this.$t('order.place.validation.selectPickupState'), trigger: "change" }],
        'q_data.city': [{ required: true, message: this.$t('order.place.validation.enterPickupCity'), trigger: "blur" }],
        'q_data.zcode': [{ required: true, message: this.$t('order.place.validation.enterPickupZip'), trigger: "blur" }],
        'q_data.address_one': [{ required: true, message: this.$t('order.place.validation.enterPickupAddress'), trigger: "blur" }],
        'q_data.mobile': [{ required: true, message: this.$t('order.place.validation.enterPickupPhone'), trigger: "blur" }],
        
        'q_package.package_all_num': [{ required: true, message: this.$t('order.place.validation.enterTotalPackages'), trigger: "blur" }],
        'q_package.all_weight': [{ required: true, message: this.$t('order.place.validation.enterTotalWeight'), trigger: "blur" }],
        'q_package.q_date': [{ required: true, message: this.$t('order.place.validation.selectPickupDate'), trigger: "change" }],
        'q_package.q_time': [{ required: true, message: this.$t('order.place.validation.selectReadyTime'), trigger: "change" }],
        'q_package.q_endtime': [{ required: true, message: this.$t('order.place.validation.selectLatestTime'), trigger: "change" }],

        Sku: [{ required: true, message: this.$t('order.place.validation.enterSku'), trigger: 'blur' }],
        pa_num: [{ required: true, message: this.$t('order.place.validation.enterPackageQuantity'), trigger: 'blur' }],
        pa_lb: [{ required: true, message: this.$t('order.place.validation.enterWeight'), trigger: 'blur' }],
        pa_length: [{ required: true, message: this.$t('order.place.validation.enterDimensions'), trigger: 'blur' }]
      }
    },
    // 当前是否为英制单位(磅/英寸)，与模板尺寸/重量单位判断保持一致
    isImperial() {
      return this.pa_unit == this.$t('order.place.unit.lbIn') || this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in'
    },
    // 当前重量单位文案：英制显示 lb，公制显示 kg
    weightUnitText() {
      return this.isImperial ? this.$t('order.place.unit.lb') : this.$t('order.place.unit.kg')
    },
    // 总重量 = Σ(单件重量 pa_lb × 包裹数量 pa_num)，保留2位小数；口径与后端测价一致
    totalCargoWeight() {
      const sum = (this.ruleForm.package_list || []).reduce((acc, item) => {
        const lb = parseFloat(item.pa_lb) || 0
        const num = parseInt(item.pa_num) || 0
        return acc + lb * num
      }, 0)
      return sum.toFixed(2)
    },
    // 总体积重量 = Σ(长×宽×高 ÷ 系数 × 包裹数量)。英寸÷139得体积磅，厘米÷5000得体积千克
    totalVolumeWeight() {
      const divisor = this.isImperial ? 139 : 5000
      const sum = (this.ruleForm.package_list || []).reduce((acc, item) => {
        const l = parseFloat(item.pa_length) || 0
        const w = parseFloat(item.pa_width) || 0
        const h = parseFloat(item.pa_height) || 0
        const num = parseInt(item.pa_num) || 0
        return acc + (l * w * h / divisor) * num
      }, 0)
      return sum.toFixed(2)
    }
  },
  mounted(){
    if(!validatenull(this.record)){
      this.id = this.record.order_id
      this.getOrderInfo()
    }
  },
  created(){
    this.pa_unit = this.$t('order.place.pa_unit')
    this.getFbaList()
    this.getCity()
    this.getServiceNameList()
    this.getAddress()
    if(this.$route.query.form){
      let form = JSON.parse(this.$route.query.form)
      this.ruleForm.send_data.zcode = form.start_zip_code
      this.ruleForm.send_data.country = form.start_country
      this.ruleForm.receive_data.zcode = form.destination_zip_code
      this.ruleForm.receive_data.country = form.destination_country
      this.ruleForm.send_data.province = 'CA'
      this.ruleForm.send_data.province = form.send_data_province
      this.ruleForm.send_data.city = form.send_data_city
      this.sendProvinceList = provinceListValue(this.countryList, 'United States')
      this.ruleForm.receive_data.province = form.receive_data_province
      this.ruleForm.receive_data.city = form.receive_data_city
      this.receiveProvinceList = provinceListValue(this.countryList, 'United States')
      // this.pa_unit = form.pa_unit == 'lb/in' ? '磅/英寸' : '千克/厘米'
      this.pa_unit = form.pa_unit == "lb/in" ? this.$t('order.place.unit.lbIn') : this.$t('order.place.unit.kgCm');
      let package_list = []
      package_list.push({
        Sku: '001',
        insurance: 0,
        itemQty: form.itemQty,
        pa_height: form.pa_height,
        pa_lb: form.pa_lb,
        pa_length: form.pa_length,
        pa_num: form.pack_num,
        pa_type: "Your Packaging",
        pa_width: form.pa_width
      })
      this.ruleForm.package_list = package_list
    }
  },
  methods: {
    // 解析地址弹窗
    handleResolution(num){
      this.resoluVisible = true
      this.resoluNum = num
    },
    // 解析结果
    resoluResult(num,obj){
      if(num == 1){
        if (obj) {
          this.ruleForm.send_data = { ...obj, province: obj.province.split("-")[0] };
          this.sendProvinceList = provinceListValue(this.countryList, obj.country);
          if (this.is_qus) this.fillPickupFromSender();
        }
      }else if(num == 2){
        if (obj) {
          this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] };
          this.receiveProvinceList = provinceListValue(this.countryList, obj.country);
          this.FbaValue = [];
        }
      }

      this.resoluVisible = false
      this.resoluNum = 0
    },
    changeTime(e){
      this.qendtimelist = findTimeIndex(this.qtimelist, e)
    },
    handleCheck(value){
      this.ruleForm.is_qu = value ? 1 : 0;
      if (value) this.fillPickupFromSender();
    },
    fillPickupFromSender() {
      const sender = this.ruleForm.send_data || {};
      const pickup = { company: '', address_two: '', email: '', ...(this.ruleForm.q_data || {}) };
      ['realname', 'company', 'country', 'province', 'city', 'zcode', 'address_one', 'address_two', 'mobile', 'email'].forEach((key) => {
        pickup[key] = sender[key] || '';
      });
      this.$set(this.ruleForm, 'q_data', pickup);
      this.qProvinceList = pickup.country ? provinceListValue(this.countryList, pickup.country) : [];
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate(['q_data.realname', 'q_data.country','q_data.province','q_data.city','q_data.zcode','q_data.address_one','q_data.mobile']);
        }
      });
    },
    clearAddress(num){
      if(num == 1){
        this.ruleForm.send_data = { company: '', address_two: '', email: '' }
        this.sendSelectValue = []
        this.sendProvinceList = []
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate(['send_data.realname', 'send_data.country','send_data.province','send_data.city','send_data.zcode','send_data.address_one','send_data.mobile'])
        })
      }else if(num == 2){
        this.ruleForm.receive_data = { company: '', address_two: '', email: '' }
        this.FbaValue = ''
        this.receiveProvinceList = []
        this.receiveSelectValue = []
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate(['receive_data.realname', 'receive_data.country','receive_data.province','receive_data.city','receive_data.zcode','receive_data.address_one','receive_data.mobile'])
        })
      }else if(num == 3){
        this.ruleForm.q_data = { company: '', address_two: '', email: '' }
        this.qProvinceList = []
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate(['q_data.realname', 'q_data.country','q_data.province','q_data.city','q_data.zcode','q_data.address_one','q_data.mobile'])
        })
      }
    },
    swapAddress() {
      const tempSend = JSON.parse(JSON.stringify(this.ruleForm.send_data));
      const tempReceive = JSON.parse(JSON.stringify(this.ruleForm.receive_data));
      const tempSendProvince = this.sendProvinceList;
      const tempReceiveProvince = this.receiveProvinceList;

      this.ruleForm.send_data = tempReceive;
      this.ruleForm.receive_data = tempSend;
      this.sendProvinceList = tempReceiveProvince;
      this.receiveProvinceList = tempSendProvince;

      this.sendSelectValue = '';
      this.receiveSelectValue = '';
      this.FbaValue = '';
      if (this.is_qus) this.fillPickupFromSender();

      this.$message.success('发件人和收件人地址已交换');
    },
    getOrderInfo(){
      orderInfo({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        order_id: this.id
      }).then(res => {
        if(res.code == 1){
          let forms = normalizeAddressOverflow(res.data)
          forms.receive_data.province = forms.receive_data.province.split("-")[0]
          forms.send_data.province = forms.send_data.province.split("-")[0]
          if(forms.q_data.province){
            forms.q_data.province = forms.q_data.province.split("-")[0]
          }
          if(forms.q_package && forms.q_package.q_date){
            forms.q_package.q_date = formatPickupDateValue(forms.q_package.q_date)
          }
          this.ruleForm = forms
          this.sendProvinceList = provinceListValue(this.countryList, forms.send_data.country)
          this.receiveProvinceList = provinceListValue(this.countryList, forms.receive_data.country)
          if(forms.q_data.country){
            this.qProvinceList = provinceListValue(this.countryList, forms.q_data.country)
          }
          if(forms.q_package.q_time){
            this.qendtimelist = findTimeIndex(this.qtimelist, forms.q_package.q_time)
          }
          this.is_qus = forms.is_qu == 1 ? true : false
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    addAddress(formName,num){
      var sendValidate = ['send_data.realname', 'send_data.country','send_data.province','send_data.city','send_data.zcode','send_data.address_one','send_data.mobile'];
      var receiveValidate = ['receive_data.realname', 'receive_data.country','receive_data.province','receive_data.city','receive_data.zcode','receive_data.address_one','receive_data.mobile'];
      var validList = num == 1 ? sendValidate : receiveValidate
      var allValid = true;
      validList.forEach(field => {
        this.$refs[formName].validateField(field, (errorMessage) => {
          if (errorMessage) allValid = false;
        });
      });
      if (allValid) {
        if(num == 1){
          addressAdd({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            user_type: 1,
            ...this.ruleForm.send_data
          }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.msg)
          })
        }else if(num == 2){
          addressAdd({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            user_type: 2,
            ...this.ruleForm.receive_data
          }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.msg)
          })
        }else{
          checkAddress({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            receive_data: {
              ...this.ruleForm.receive_data,
              province: this.ruleForm.receive_data.province.split("-")[0]
            }
          }).then(res => {
            if(res.code == 1){
              this.checkVisible = true
              this.checkInfo = res.data
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.msg)
          })
        }
      }
    },
    closeCheckDialog(){
      this.checkVisible = false
      this.checkInfo = {}
    },
    closeCheck(){
      this.checkVisible = false
      this.checkInfo = {}
    },
    getAddress(){
      address({
        user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: 0
      }).then(res => {
        if(res.code == 1){
          res.data.list.forEach(item => {
            item.user_type == 1 ? this.send_list.push(item) : this.receive_list.push(item)
          })
        }
      })
    },
    getFbaList(){
      fbaList({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code
      }).then(res => {
        this.fbaLists = res.data
      })
    },
    getServiceNameList(){
      serviceNameList({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code
      }).then(res =>{
        let ups = [
          { label: 'Customer Supplied Package' },
          { label: 'UPS Letter' },
          { label: 'Tube' },
          { label: 'PAK' },
          { label: 'UPS Express Box' },
          { label: 'UPS 25KG Box' },
          { label: 'UPS 10KG Box' },
          { label: 'Pallet' },
          { label: 'Small Express Box' },
          { label: 'Medium Express Box' },
          { label: 'Large Express Box' },
          { label: 'Flats' },
          { label: 'Parcels' },
          { label: 'BPM' },
          { label: 'First Class' },
          { label: 'Priority' },
          { label: 'Machinables' },
          { label: 'Irregulars' },
          { label: 'Parcel Post' },
          { label: 'BPM Parcel' },
          { label: 'Media Mail' },
          { label: 'BPM Flat' },
          { label: 'Standard Flat' }
        ]
        let FedEx = [
          { label: 'YOUR_PACKAGING' },
          { label: 'FEDEX_BOX' },
          { label: 'FEDEX_ENVELOPE' },
          { label: 'FEDEX_PAK' },
          { label: 'FEDEX_TUBE' },
          { label: 'FEDEX_SMALL_BOX' }
        ]
        this.channelList = res.data.map(item => {
          let child = item.type == 1 ? ups : (item.type == 0 ? FedEx : []) 
          return { ...item, child }
        })
      })
    },
    getCity(){
      City().then(res => {
        this.countryList = transformCountryCity(res.data)
        this.sendProvinceList = provinceListValue(this.countryList, 'United States')
        this.receiveProvinceList = provinceListValue(this.countryList, 'United States')
      })
    },
    getCityInfo(num){
      let zcode = num == 1 ? this.ruleForm.send_data.zcode : ( num == 2 ? this.ruleForm.receive_data.zcode : this.ruleForm.q_data.zcode)
      cityInfo({ zcode }).then(res => {
        if(res.code == 1){
          if(num == 1){
            this.ruleForm.send_data.country = 'United States'
            this.$set(this.ruleForm.send_data, 'province', res.data.province);
            this.$set(this.ruleForm.send_data, 'city', res.data.city);
            this.sendProvinceList = provinceListValue(this.countryList, 'United States')
          } else if(num == 2){
            this.ruleForm.receive_data.country = 'United States'
            this.$set(this.ruleForm.receive_data, 'province', res.data.province);
            this.$set(this.ruleForm.receive_data, 'city', res.data.city);
            this.receiveProvinceList = provinceListValue(this.countryList, 'United States')
          } else if(num == 3){
            this.ruleForm.q_data.country = 'United States'
            this.$set(this.ruleForm.q_data, 'province', res.data.province);
            this.$set(this.ruleForm.q_data, 'city', res.data.city);
            this.qProvinceList = provinceListValue(this.countryList, 'United States')
          }
        }
      })
    },
    handleSendChange(value) {
      this.sendProvinceList = provinceListValue(this.countryList, value)
      delete this.ruleForm.send_data.province
    },
    handleReceiveChange(value) {
      this.receiveProvinceList = provinceListValue(this.countryList, value)
      delete this.ruleForm.receive_data.province
    },
    handleQChange(value) {
      this.qProvinceList = provinceListValue(this.countryList, value)
      delete this.ruleForm.q_data.province
    },
    normalizePickupDate(form) {
      if(form && form.q_package && form.q_package.q_date){
        form.q_package = { ...form.q_package, q_date: formatPickupDateValue(form.q_package.q_date) }
      }
      return form
    },
    handleFree(formName){
      var validList = ['send_data.realname', 'send_data.country','send_data.province','send_data.city','send_data.zcode','send_data.address_one','send_data.mobile','receive_data.realname', 'receive_data.country','receive_data.province','receive_data.city','receive_data.zcode','receive_data.address_one','receive_data.mobile'];
      var qlist = ['q_data.realname', 'q_data.country','q_data.province','q_data.city','q_data.zcode','q_data.address_one','q_data.mobile','q_package.package_all_num','q_package.all_weight','q_package.q_date','q_package.q_time','q_package.q_endtime']
      if(this.is_qus) validList = validList.concat(qlist)
      this.ruleForm.package_list.forEach((item,index) => {
        validList.push(`package_list[${index}][Sku]`)
        validList.push(`package_list[${index}][pa_num]`)
        validList.push(`package_list[${index}][pa_length]`)
        validList.push(`package_list[${index}][pa_lb]`)
      })
      var allValid = true;
      validList.forEach(field => {
        this.$refs[formName].validateField(field, (errorMessage) => {
          if (errorMessage) allValid = false;
        });
      });
      if(allValid){
        let form = { ...this.ruleForm, user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code }
        form = this.normalizePickupDate(form)
        let package_list = form.package_list.map(item => {
          let pa_unit = (this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in') ? 1 : 2
          return { ...item, pa_unit, pa_type: '', pa_height: item.pa_height || 1, pa_length: item.pa_length || 1, pa_width: item.pa_width || 1 }
        })
        form.package_list = package_list
        form.receive_data.province = form.receive_data.province.split("-")[0]
        form.send_data.province = form.send_data.province.split("-")[0]
        if(form.q_data.province) form.q_data.province = form.q_data.province.split("-")[0]
        if(form.receive_data.remark || form.receive_data.remark == '') delete form.receive_data.remark
        if(!form.receive_data.email) form.receive_data.email = ''
        if(form.receive_data.id) delete form.receive_data.id
        if(form.receive_data.user_type) delete form.receive_data.user_type
        if(form.send_data.remark || form.send_data.remark == '') delete form.send_data.remark
        if(form.send_data.user_type) delete form.send_data.user_type
        if(form.send_data.id) delete form.send_data.id
        if(!form.send_data.email) form.send_data.email = ''
        if(!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = ''
        delete form.goods_info.order_sn;
        this.freeLoading = true
        this.rateProgressVisible = true
        this.$nextTick(() => {
          this.$refs.rateProgress && this.$refs.rateProgress.startStream(form)
        })
      }
    },
    getRatesInfo(info){
      this.ratesMoney = info.all_money
      this.ratesWeight = info.weight
      this.ruleForm.goods_info.service_type = info.service_type
      this.$set(this.ruleForm.goods_info, 'pservice_type', info.service_name)
      this.freeVisible = false
    },
    closeFreeDialog(){
      this.freeVisible = false
    },
    onRateStreamComplete(event) {
      this.freeLoading = false
      if (event.code == 1) {
        this.$message.success(event.msg)
        this.freeInfo = event.data
        this.freeVisible = true
      } else {
        this.$message.error(event.msg || this.$t('order.place.message.predictFailed'))
      }
    },
    onRateStreamError(err) {
      this.freeLoading = false
      this.$message.error(err.message || this.$t('order.place.message.predictFailed'))
    },
    // 用户主动点叉号取消测价：仅收尾按钮 loading，不弹错误提示
    onRateStreamAbort() {
      this.freeLoading = false
    },
    selectOneself(obj){
      this.ruleForm.send_data = { ...obj }
      this.sendProvinceList = provinceListValue(this.countryList, obj.country)
      this.sendSelectValue = []
      if (this.is_qus) this.fillPickupFromSender();
    },
    changePservice(e){},
    // 选择包裹类型时自动填充标准长宽高(英寸,与国际单 fplace 保持一致;自定义包装等不在表中的类型则清空)
    handlePackageTypeChange(val, index) {
      const sizeMap = {
        'Your 10kg Box': { pa_length: '15.81', pa_width: '12.94', pa_height: '10.19' },
        'Your 25kg Box': { pa_length: '21.56', pa_width: '16.56', pa_height: '13.19' },
        'Your Envelope': { pa_length: '13.19', pa_width: '9.25', pa_height: '' },
        'Your Extra Large Box': { pa_length: '11.88', pa_width: '11', pa_height: '10.75' },
        'Your Large Box': { pa_length: '17.88', pa_width: '12.38', pa_height: '3' },
        'Your Medium Box': { pa_length: '13.25', pa_width: '11.5', pa_height: '2.38' },
        'Your Pak': { pa_length: '14.75', pa_width: '11.75', pa_height: '' },
        'Your Small Box': { pa_length: '12.25', pa_width: '10.9', pa_height: '1.5' },
        'Your Tube': { pa_length: '38', pa_width: '6', pa_height: '6' },
      };
      const size = sizeMap[val];
      if (size) {
        this.$set(this.ruleForm.package_list[index], 'pa_length', size.pa_length);
        this.$set(this.ruleForm.package_list[index], 'pa_width', size.pa_width);
        this.$set(this.ruleForm.package_list[index], 'pa_height', size.pa_height);
      } else {
        this.$set(this.ruleForm.package_list[index], 'pa_length', '');
        this.$set(this.ruleForm.package_list[index], 'pa_width', '');
        this.$set(this.ruleForm.package_list[index], 'pa_height', '');
      }
    },
    selectSendAddr(e){
      let obj = this.send_list.find(item => item.id == e)
      if(obj){
        this.ruleForm.send_data = { ...obj, province:obj.province.split("-")[0] }
        this.sendProvinceList = provinceListValue(this.countryList, obj.country)
        if (this.is_qus) this.fillPickupFromSender();
      }
    },
    selectReceiveAddr(e){
      let obj = this.receive_list.find(item => item.id == e)
      if(obj){
        this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] }
        this.receiveProvinceList = provinceListValue(this.countryList, obj.country)
        this.FbaValue = []
      }
    },
    selectFBAAddr(e){
      let obj = this.fbaLists.find(item => item.id == e)
      if(obj){
        this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] }
        this.receiveProvinceList = provinceListValue(this.countryList, obj.country)
        this.receiveSelectValue = []
      }
    },
    openImmediatePay(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        if (!this.ratesMoney || !this.ruleForm.goods_info.pservice_type || !this.ruleForm.goods_info.service_type) {
          this.$message.warning(this.$t('recharge.orderRateRequired'))
          return
        }
        this.payVisible = true
      })
    },
    onImmediatePaySuccess() {
      this.submitForm('ruleForm')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = { ...this.ruleForm, user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code }
          form = this.normalizePickupDate(form)
          let package_list = form.package_list.map(item => {
            let pa_unit = (this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in') ? 1 : 2
            return { ...item, pa_unit, pa_height: item.pa_height || 1, pa_length: item.pa_length || 1, pa_width: item.pa_width || 1 }
          })
          form.package_list = package_list
          form.receive_data.province = form.receive_data.province.split("-")[0]
          form.send_data.province = form.send_data.province.split("-")[0]
          if(form.q_data.province) form.q_data.province = form.q_data.province.split("-")[0]
          if(form.receive_data.remark || form.receive_data.remark == '') delete form.receive_data.remark
          if(form.receive_data.id) delete form.receive_data.id
          if(form.receive_data.user_type) delete form.receive_data.user_type
          if(form.send_data.remark || form.send_data.remark == '') delete form.send_data.remark
          if(!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = ''
          if(form.send_data.user_type) delete form.send_data.user_type
          if(form.send_data.id) delete form.send_data.id
          // AI订单打单后订单号继续以AI开头：优先用表单值，缺失时从列表行(record)兜底
          var aiOrderSn = (form.goods_info.order_sn && /^AI/.test(form.goods_info.order_sn))
            ? form.goods_info.order_sn
            : ((this.record && this.record.order_sn && /^AI/.test(this.record.order_sn)) ? this.record.order_sn : '')
          if(aiOrderSn){
            form.goods_info.order_sn = aiOrderSn
          }else{
            delete form.goods_info.order_sn;
          }
          this.orderLoading = true
          orderCreate(form).then(res => {
            this.orderLoading = false
            if(res.code == 1 && res.data && res.data.status == 1){
              this.$message.success(res.msg)
              if(this.id){
                this.$emit('orderSuccess')
              }else{
                this.$router.push({ path: '/bill/list'})
              }
            }else{
              const errMsg = (res.code == 1 && res.data && res.data.text) ? res.data.text : (res.msg || '下单失败')
              this.$alert(errMsg.replace(/\n/g, '<br>'), '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认'
              })
            }
          }).catch(err => {
            this.orderLoading = false
            this.$message.error(this.$t('order.place.message.createOrderFailed'))
          })
        } else {
          return false;
        }
      });
    },
    storeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = { ...this.ruleForm, user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code }
          form = this.normalizePickupDate(form)
          let package_list = form.package_list.map(item => {
            let pa_unit = (this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in') ? 1 : 2
            return { ...item, pa_unit, pa_height: item.pa_height || 1, pa_length: item.pa_length || 1, pa_width: item.pa_width || 1 }
          })
          form.package_list = package_list
          form.receive_data.province = form.receive_data.province.split("-")[0]
          form.send_data.province = form.send_data.province.split("-")[0]
          if(form.receive_data.remark || form.receive_data.remark == '') delete form.receive_data.remark
          if(form.receive_data.id) delete form.receive_data.id
          if(form.receive_data.user_type) delete form.receive_data.user_type
          if(form.send_data.remark || form.send_data.remark == '') delete form.send_data.remark
          if(!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = ''
          if(form.send_data.user_type) delete form.send_data.user_type
          if(form.send_data.id) delete form.send_data.id
          delete form.goods_info.order_sn;
          this.storeLoading = true
          storeOrder(form).then(res => {
            this.storeLoading = false
            if(res.code == 1){
              this.$message.success(res.msg)
              if(this.id){
                this.$emit('orderSuccess')
              }else{
                this.$router.push({ path: '/bill/list'})
              }
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.storeLoading = false
            this.$message.error(this.$t('order.place.message.createOrderFailed'))
          })
        } else {
          return false;
        }
      });
    },
    submitDraftForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = { ...this.ruleForm, user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code }
          form = this.normalizePickupDate(form)
          let package_list = form.package_list.map(item => {
            let pa_unit = (this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in') ? 1 : 2
            return { ...item, pa_unit, pa_height: item.pa_height || 1, pa_length: item.pa_length || 1, pa_width: item.pa_width || 1 }
          })
          form.package_list = package_list
          form.receive_data.province = form.receive_data.province.split("-")[0]
          form.send_data.province = form.send_data.province.split("-")[0]
          if(form.q_data.province) form.q_data.province = form.q_data.province.split("-")[0]
          if(form.receive_data.remark || form.receive_data.remark == '') delete form.receive_data.remark
          if(form.receive_data.id) delete form.receive_data.id
          if(form.receive_data.user_type) delete form.receive_data.user_type
          if(form.send_data.remark || form.send_data.remark == '') delete form.send_data.remark
          if(form.send_data.user_type) delete form.send_data.user_type
          if(form.send_data.id) delete form.send_data.id
          if(!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = ''
          delete form.goods_info.order_sn;
          this.draftLoading = true
          saveOrder(form).then(res => {
            this.draftLoading = false
            if(res.code == 1){
              this.$message.success(res.msg)
              if(this.id){
                this.$emit('orderSuccess')
              }else{
                this.$router.push({ path: '/bill/list'})
              }
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.draftLoading = false
            this.$message.error(this.$t('order.place.message.saveDraftFailed'))
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.sendSelectValue = []
      this.receiveSelectValue = []
      this.sendProvinceList = []
      this.receiveProvinceList = []
      this.qProvinceList=[]
      this.pa_type_list = [
        { label: "Your 10kg Box" },
        { label: "Your 25kg Box" },
        { label: "Your Envelope" },
        { label: "Your Extra Large Box" },
        { label: "Your Large Box" },
        { label: "Your Medium Box" },
        { label: "Your Pak" },
        { label: "Your Small Box" },
        { label: "Your Tube" },
        { label: "Your Packaging" },
      ];
      this.pa_unit = this.$t('order.place.pa_unit')
      this.FbaValue = ''
      this.freeInfo = {}
      this.checkInfo = {}
      this.ratesMoney = ''
      this.ratesWeight = ''
      this.ruleForm = {
        goods_info:{ is_sign: 0, service_type: "", USPSEndorsement: 1 },
        package_list: [
          { Sku: "001", insurance: 0, pa_height: '', pa_lb: '', pa_length: '', pa_num: 1, itemQty: 1, pa_type: "Your Packaging", pa_width: '' }
        ],
        receive_data: { company: '', address_two: '', address_three: '', email: '' },
        send_data: { company: '', address_two: '', address_three: '', email: '' },        
        is_qu: 0,
        q_data: { company: '', address_two: '' },
        q_package: {}
      }
      this.is_qus = false
      this.qendtimelist = []
      this.$refs[formName].resetFields();
    },
    addParcel(){
      let obj = { Sku: "001", insurance: 0, pa_height: '', pa_lb: '', pa_length: '', pa_num: 1, pa_type: "Your Packaging", pa_width: '', itemQty: 1 }
      this.ruleForm.package_list.push(obj)
    },
    delParcel(num){
      this.ruleForm.package_list.splice(num, 1)
    },
    copyParcel(num,item){
      let pa_num = item.pa_num
      if(item.pa_num > 1){
        this.ruleForm.package_list[num].pa_num = 1
        for(var i = 1; i < pa_num; i++){
          let obj = { ...item, pa_num: 1 }
          this.ruleForm.package_list.push({...obj});
        }
      }else{
        this.ruleForm.package_list.push({...item});
      }
    }
  },
};
</script>
<style lang="scss" scoped>
  .place{
    background: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    .place-title{
      width: 100%;
      font-size: 15px;
      line-height: 24px;
      text-align: left;
      color: #409EFF;
    }
    .border-col{
      border-bottom: 1px solid #409EFF;
      margin-bottom: 10px;
      padding-bottom: 5px;
    }
  }
  /deep/.el-form-item__content{
    text-align: left;
  }
  .add-select-btn{
    margin-left: 30px;
  }
  .parcel-item{
    width: 100%;
    background: rgba(64,158,255,0.1);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 10px;
    .parcel-top{
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom:1px solid #BEE6F7;
      margin-bottom:10px;
      padding-bottom:10px;
      .parcel-title{
        font-size: 14px;
      }
    }
    .parcel-lwh{
      display: flex;
      align-items: center;
       /deep/ input::-webkit-outer-spin-button,
      /deep/ input::-webkit-inner-spin-button {
        -webkit-appearance: none!important;
      }
      /deep/ input[type="number"]{
        -moz-appearance: textfield;
      }
    }
    .place-box{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .tips{
    font-size: 14px;
    color: red;
    padding-left: 10px;
  }
  .bttn{
    text-align:right;
    margin-top: 10px;
    font-size: 14px;
    display:flex;
    justify-content: flex-end;
    align-items: center;
  }
  .free-rate{
    font-size: 14px;
    display: flex;
    align-items: center;
    margin: 0 10px;
    span{
      color: #E6A23C;
      font-size: 16px;
    }
  }
  .check-dialog{
    /deep/.el-dialog__body{
      padding: 0 20px !important;
    }
  }
</style>
